import clsx from 'clsx';
import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';




const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      marginBottom: theme.spacing(1),
      color: theme.palette.text.secondary,
    },
    gridItem: {
        display: 'flex',
        flexFlow: 'row wrap',
        gridGap: '5px',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: theme.spacing(1),
        [theme.breakpoints.up('md')]: {
          // Muestra 3 columnas para pantallas medianas y grandes
          '& > *': {
            flex: '0 0 calc(33.33% - 3px)',
          },
        },
        [theme.breakpoints.up('lg')]: {
          // Muestra 4 columnas para pantallas grandes
          '& > *': {
            flex: '0 0 calc(25% - 3px)',
          },
        }
    },
    selected: { 
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
      color: '#fff',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        color: '#fff',
        cursor: 'pointer',
        transition: '0.5s',
      },
      '&:active': {
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        color: '#fff'
        }
        }

  }));

export function CenteredGrid(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        <Grid onClick={props.onClick} item xs={props.xs}>
          <Paper className={classes.paper}>
            {props.text}
            {props.subGridItems.map((item, index) => (
              <Grid className={classes.gridItem} item xs={12} key={index}>
                {item}
              </Grid>
            ))}
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}

export function GridProps({ xs, item, totalHoras, index, selectedItems, onClick, style }) {

  const classes = useStyles();

  const isSelected = selectedItems.includes(index);

  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        <Grid onClick={onClick} item xs={xs}>
            <Paper className={clsx(classes.paper, { [classes.selected]: isSelected })}
            onClick={() => onClick(index)}>
              
            <Grid className={classes.gridItem} style={style}>
            {item.map((hora, index) => (
                <div key={index}  >
                  {hora}<br />
                </div>
              ))}
              </Grid>
            </Paper>
        </Grid>
      </Grid>
    </div>
  );
}
